import { render, staticRenderFns } from "./KeywordsEditor.vue?vue&type=template&id=da5fc284&"
import script from "./KeywordsEditor.vue?vue&type=script&lang=js&"
export * from "./KeywordsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports